import React, { useCallback } from "react";
import {
  Space,
  Avatar,
  Col,
  Drawer,
  Row,
  Typography,
  Divider,
  Button,
} from "antd";

import moment from "moment";
import { useNavigate } from "react-router-dom";
import { startCase } from "lodash";
import { useReadNotificationMutation } from "../redux/services/tasks";

const NotificationDrawer = ({ setOpen, open, notifications }) => {
  const navigate = useNavigate();
  const [readNotification] = useReadNotificationMutation();

  const handleRead = useCallback(
    async (id, read, taskId) => {
      if (read) {
        taskId && navigate(`/task-list/${taskId}`);
        setOpen();
        return;
      }
      await readNotification(id);
      taskId && navigate(`/task-list/${taskId}`);
      setOpen();
    },
    [readNotification, navigate, setOpen]
  );
  const handleViewDetails = useCallback(
    async (id, link, read) => {
      if (read) {
        link && navigate(link);
        setOpen();
        return;
      }
      await readNotification(id);
      link && navigate(link);
      setOpen();
    },
    [readNotification, navigate, setOpen]
  );

  return (
    <Drawer
      title="Notifications"
      placement="right"
      onClose={() => setOpen(false)}
      open={open}
    >
      {notifications?.map((notification, index) => (
        <Row gutter={[0, 0]} key={index} style={{ cursor: "pointer" }}>
          <Col span={24}>
            <Row
              justify={""}
              align={"top"}
              gutter={[40, 0]}
              size="large"
              onClick={() =>
                handleRead(
                  notification?.id,
                  notification?.read_at,
                  notification?.attributes?.task_id
                )
              }
            >
              <Col span={2}>
                <Avatar
                  style={{
                    background: "green",
                  }}
                  size="default"
                >
                  {startCase(notification?.created_by?.charAt(0))}
                </Avatar>
              </Col>
              <Col span={17}>
                <Space direction="vertical">
                  <Typography.Text>{notification.title}</Typography.Text>
                  <Typography.Text type="secondary">
                    {moment(notification?.created_at).fromNow()}
                  </Typography.Text>
                </Space>
              </Col>
            </Row>
            <Col span={24}>
              <Row justify={"end"}>
                <Col>
                  <Button
                    size="small"
                    type={notification?.read_at ? "ghost" : "primary"}
                    onClick={() =>
                      handleViewDetails(
                        notification?.id,
                        notification?.attributes?.actions?.find(
                          (item) => item.type === "link_action"
                        )?.link,
                        notification?.read_at
                      )
                    }
                  >
                    View Details
                  </Button>
                </Col>
              </Row>
            </Col>
            <Divider style={{ margin: "10px 0" }} />
          </Col>
        </Row>
      ))}
    </Drawer>
  );
};

export default NotificationDrawer;
